"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
const GaugeOverflow = _styledComponents.default.div`
	${({
  gaugeSize
}) => `
    position: relative;
    overflow: hidden;
    width: ${gaugeSize}px;
    height: ${gaugeSize / 2}px;
    margin-bottom: -14px;
`}
`;
var _default = exports.default = GaugeOverflow;
module.exports = exports.default;
module.exports.default = exports.default;